import { DateTime } from "luxon"

export const getMonths = (start: string, end: string) => {
  const startDate = DateTime.fromISO(start)
  const endDate = DateTime.fromISO(end)
  let currentDate = startDate.startOf("month")
  const months: DateTime[] = []

  while (currentDate < endDate) {
    months.push(currentDate)
    currentDate = currentDate.plus({ month: 1 })
  }

  return months
}
